import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/Icons/hidden.svg'


const _hoisted_1 = { class: "ui-input-with-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

import { ref, computed, onMounted, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ui-input-withIcon',
  props: {
	data: { type: Boolean, value: true },
	text: { type: String, default: "" },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

// Импорты из Vue 3 Composition API
const isPassword = ref(true);
const field = ref("");

// // Определение пропсов компонента
const props = __props;

// // Определение эмиттеров событий компонента
const emits = __emit;

// // Отслеживание изменений пропса isCompact
// watch(
//   () => props.isCompact,
//   () => {
//     if (props.isCompact) {
//       console.log("Свойство isCompact поменялось на true");
//     }
//   }
// );

// const latitude = computed({
// get() {
// return lat.value || props.Latitude || 0;
// },
// set(newValue: number) {
// console.log(`newValue`, newValue);
// lat.value = newValue;
// },
// });
// // Блок переменных
// const count = ref(0); // Переменная для подсчета
// const message = ref(""); // Переменная для сообщения

// // Жизненный цикл компонента (при монтировании)
// onMounted(() => {
//   console.log("Компонент монтирован.");
// });

// // Вычисляемое свойство (двойное значение счетчика)
// const doubledCount = computed(() => count.value * 2);

// // Функция для увеличения счетчика
// function increment() {
//   count.value++;
// }

// // Функция для изменения сообщения и эмиттинга события обновления
// function changeMessage() {
//   message.value = "Новое сообщение!";
//   emits("update:message", message.value);
// }

return (_ctx: any,_cache: any) => {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_ui_input, {
        type: isPassword.value ? 'Password' : 'Text',
        modelValue: field.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((field).value = $event)),
        headerText: _ctx.$localization.getTranslate('Your password'),
        warningMsg: _ctx.$localization.getTranslate('FillThisField'),
        required: ""
      }, null, 8, ["type", "modelValue", "headerText", "warningMsg"])
    ]),
    _createVNode(_component_ui_button, {
      class: "bnt-icon",
      onClick: _ctx.$emits.click
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "icon", {}, () => [
          _hoisted_2
        ])
      ]),
      _: 3
    }, 8, ["onClick"])
  ]))
}
}

})